"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Overlay", {
  enumerable: true,
  get: function get() {
    return _Overlay2.default;
  }
});

var _Overlay2 = _interopRequireDefault(require("./Overlay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/overlay/index.js
// module id = ./node_modules/quark-web/components/overlay/index.js
// module chunks = 0